<div class="tourists-dropdown">
  <div class="tourists-section">
    <div class="tourists-label">Взрослых:</div>
    <div class="tourists-select">
      <button type="button" class="tourists-select-btn" (click)="toggleAdultsSelect()">
        {{ getAdultsLabel() }}
      </button>
      @if (isShowAdultsSelect) {
        <div class="tourists-select-list">
          @for (count of adultsOptions; track count) {
            <button type="button"
                    class="select-option"
                    [ngClass]="{active: count === adults}"
                    (click)="selectAdults(count)">
              {{ count }} {{ count === 1 ? 'взрослый' : 'взрослых' }}
            </button>
          }
        </div>
      }
    </div>
  </div>

  <div class="tourists-divider"></div>

  <div class="tourists-section">
    <div class="tourists-label">Возраст детей:</div>
    <div class="children-fields">
      @for (childAge of childAgeFields; track $index; let i = $index) {
        <div class="tourists-select">
          <button type="button" class="tourists-select-btn" (click)="toggleChildSelect(i)">
            {{ getChildAgeLabel(i) }}
          </button>
          @if (openedChildSelectIndex === i) {
            <div class="tourists-select-list">
              @if (childAge !== null || childAgeFields.length > 1) {
                <button type="button" class="select-option remove" (click)="removeChildField(i)">Убрать ребенка</button>
              }
              <button type="button" class="select-option" (click)="selectChildAge(i, 0)">до 1 года</button>
              @for (age of ages; track age) {
                <button type="button" class="select-option" (click)="selectChildAge(i, age)">{{ getAgeLabel(age) }}</button>
              }
            </div>
          }
        </div>
      }
    </div>

    @if (childAgeFields.length < 4) {
      <button type="button" class="btn-add-children" (click)="addChildField()">
        Добавить ребенка
      </button>
    }
  </div>

  @if (isShowSplitRooms) {
    <div class="split-rooms">
      <div class="split-rooms-hint">
        Совет: иногда бронировать туры с раздельными номерами
        выгоднее, чем с одним
      </div>

      <div class="ng-checkbox">
        <input type="checkbox" [checked]="isSplitRooms" (change)="changeSplitRoomsCheckbox($event)"
               id="search-form-split-rooms-switch">
        <label for="search-form-split-rooms-switch">
          <div class="ng-value">Показывать туры<br> с 2-мя номерами</div>
        </label>
      </div>
    </div>
  }
</div>
